function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../../../core-video-internal';
import { AdInsertionStrategy, AdsFailoverReason, DvrWindowDuration, PlaybackType, StreamQuality, StreamVendor } from '../../../../core/player/playout-data';
import { TelemetryNotificationKey } from '../../../../core/telemetry/telemetry-session';
import { sdkLogger } from '../../../../logger';
import { LegacyMediaTailorAdBreaksProvider } from '../../../../players/bolt-ons/ad-breaks-provider/legacy-media-tailor-ad-breaks-provider';
import { AdEventsManager } from '../../../../players/bolt-ons/ad-events-manager';
import { AdTransitionType, SessionSideAdTransitionBoltOn } from '../../../../players/bolt-ons/session-side-ad-transition-bolt-on';
import { AdPolicyManager } from '../../../../propositions/ad-policy/ad-policy-manager';
import { getLgWebOsVersion } from '../../../../utils/device-type';
import { JsonUtils } from '../../../../utils/json-utils';
import { PerfKey, perfLogger, PerfTag } from '../../../../utils/perf';
import { checkIsManifestLinearType, checkIsManifestVodType } from '../../../../utils/playback-type';
import { promiseWithTimeout } from '../../../../utils/promise-utils';
import { HARMONIC_2M_PATH, HARMONIC_EVENT_PATH } from '../../../../utils/stream-vendor';
import { appendQueryParams } from '../../../../utils/url-builder';
import { AdInsertionType } from '../../../ad-insertion-type';
import { ContentType } from '../../../addon-playout-data';
import { Vac } from '../../../vac/vac-addon';
import { AdBreakUpdateMergeStrategy } from '../../common';
import { ServerAdvertsAddon } from '../server-adverts-addon';
import { AdsTrackingController } from '../../../../players/bolt-ons/ads-tracking-controller';
import { isEmptyAdBreak } from '../../../../utils/ad-break-utils';
var CDN_TOKEN_PARAM_NAME = 'c3.ri';
var AD_BREAK_START_TOLERANCE_LOW_END = 1.3;
var AD_BREAK_START_TOLERANCE = 0.7;
export var MediaTailorAddon = /*#__PURE__*/ function(ServerAdvertsAddon) {
    "use strict";
    _inherits(MediaTailorAddon, ServerAdvertsAddon);
    function MediaTailorAddon(config, session, pauseAdDispatcher, companionAdDispatcher, sessionItem) {
        _class_call_check(this, MediaTailorAddon);
        var _this;
        _this = _call_super(this, MediaTailorAddon, [
            sessionItem.type
        ]), _define_property(_this, "config", void 0), _define_property(_this, "session", void 0), _define_property(_this, "companionAdDispatcher", void 0), _define_property(_this, "sessionItem", void 0), _define_property(_this, "name", void 0), _define_property(_this, "playoutOptions", void 0), _define_property(_this, "adsTrackingController", void 0), _define_property(_this, "adPolicyManager", void 0), _define_property(_this, "adBreaksProvider", void 0), _define_property(_this, "adEventsManager", void 0), _define_property(_this, "sessionSideAdTransitionBoltOn", void 0), _define_property(_this, "vacDataParams", void 0), _define_property(_this, "usingExtendedDvrWindowSessionWorkaround", void 0), _define_property(_this, "isDestroyed", void 0), _define_property(_this, "vacHeaders", void 0), _define_property(_this, "handleSessionStateChanged", void 0), _define_property(_this, "getCorrectMtUrl", void 0), _define_property(_this, "handleAdEventsManagerAdBreakDataChanged", void 0), // session filters out empty ad breaks
        _define_property(_this, "handleAdBreakStarted", void 0), _define_property(_this, "handleAdStarted", void 0), _define_property(_this, "handleAdFinished", void 0), _define_property(_this, "handleAdBreakFinished", void 0), _define_property(_this, "handleCatchupSeek", void 0), _define_property(_this, "dispatchAdBreaks", void 0), _define_property(_this, "tryDispatchAdBreaks", void 0), _define_property(_this, "handleTelemetryUpdate", void 0), _this.config = config, _this.session = session, _this.companionAdDispatcher = companionAdDispatcher, _this.sessionItem = sessionItem, _this.name = 'MediaTailorSSAI', _this.playoutOptions = {
            adInsertionStrategy: AdInsertionStrategy.SSAI,
            isPlayerAdEventsRequired: false,
            isPlayerAdBreakDataRequired: false,
            isTimelineAdManagementRequired: false,
            adProvider: AdInsertionType.MediaTailor
        }, _this.usingExtendedDvrWindowSessionWorkaround = false, _this.isDestroyed = false, _this.handleSessionStateChanged = function(state) {
            _this.adBreaksProvider.onSessionStateChanged(state);
        }, _this.getCorrectMtUrl = function(isUhd) {
            if (!isUhd) {
                return _this.config.mtUrl;
            }
            if (!_this.config.mtUhdUrl) {
                return;
            }
            return _this.config.mtUhdUrl;
        }, _this.handleAdEventsManagerAdBreakDataChanged = function(adBreaks) {
            _this.adBreakTimeAdapter.initialise(adBreaks);
            _this.adPolicyManager.setAdBreaksData(adBreaks);
            // ad-policy-manager will filter out empty ad breaks
            _this.session.notifyAdBreakDataReceived(adBreaks);
        }, _this.handleAdBreakStarted = function(adBreak) {
            if (isEmptyAdBreak(adBreak)) {
                return;
            }
            _this.sessionSideAdTransitionBoltOn.notifyAdTransition(AdTransitionType.Start);
            var clientAdBreak = _this.adBreakTimeAdapter.adBreakPositionIncludingAdsToContentPosition(adBreak);
            _this.session.notifyAdBreakStarted(clientAdBreak);
        }, _this.handleAdStarted = function(ad) {
            _this.session.notifyAdStarted(ad);
        }, _this.handleAdFinished = function(ad) {
            _this.session.notifyAdFinished(ad);
        }, _this.handleAdBreakFinished = function(adBreak) {
            if (isEmptyAdBreak(adBreak)) {
                return;
            }
            _this.sessionSideAdTransitionBoltOn.notifyAdTransition(AdTransitionType.End);
            var clientAdBreak = _this.adBreakTimeAdapter.adBreakPositionIncludingAdsToContentPosition(adBreak);
            _this.session.notifyAdBreakFinished(clientAdBreak);
        }, _this.handleCatchupSeek = function(catchupSeek) {
            var currentAdBreak = _this.adEventsManager.getCurrentAdBreak();
            if (!currentAdBreak) {
                return;
            }
            _this.adEventsManager.handleAdsSkipped(currentAdBreak.id, catchupSeek);
        }, _this.dispatchAdBreaks = function(adBreakData) {
            _this.adEventsManager.handleAdBreakDataReceived(adBreakData);
        }, _this.tryDispatchAdBreaks = function(adBreakUpdate) {
            var currentAdBreak = _this.adEventsManager.getCurrentAdBreak();
            // When midroll is received in order to preserve pre roll
            // we need following business logic to merge rather than overwrite example device:Android TV
            if (_this.isInCSAIPreRoll(currentAdBreak)) {
                adBreakUpdate.mergeStrategy = AdBreakUpdateMergeStrategy.Merge;
            }
            _this.dispatchAdBreaks(adBreakUpdate);
        }, _this.handleTelemetryUpdate = function(event) {
            _this.session.updateTelemetryMetrics(event);
        };
        _this.logger = sdkLogger.withContext(_this.name);
        var adBreakStartTolerance = _this.getAdBreakStartTolerance();
        var adBreakEndTolerance = _this.getAdBreakEndTolerance();
        _this.adPolicyManager = new AdPolicyManager({
            proposition: session.getProposition(),
            isSeekManagementRequired: true,
            isWatchedAdsManagementRequired: true,
            allowSeekingDuringAdBreaks: checkIsManifestLinearType(sessionItem.type),
            allowAdSkipCatchup: true,
            sessionItem: sessionItem,
            adBreakEndTolerance: adBreakEndTolerance
        });
        _this.sessionSideAdTransitionBoltOn = new SessionSideAdTransitionBoltOn();
        _this.adEventsManager = new AdEventsManager({
            adPolicyManager: _this.adPolicyManager,
            session: session,
            playbackType: sessionItem.type,
            adBreakStartTolerance: adBreakStartTolerance
        });
        _this.adBreaksProvider = new LegacyMediaTailorAdBreaksProvider(pauseAdDispatcher, _this.companionAdDispatcher, sessionItem.type);
        _this.adsTrackingController = new AdsTrackingController(_this.adEventsManager, session);
        _this.session.onStateChanged(_this.handleSessionStateChanged);
        _this.adBreaksProvider.onAdBreakDataReceived(_this.tryDispatchAdBreaks);
        _this.adBreaksProvider.onTelemetryUpdateReceived(_this.handleTelemetryUpdate);
        _this.adEventsManager.onAdBreakDataChanged(_this.handleAdEventsManagerAdBreakDataChanged, _this);
        _this.adEventsManager.onAdBreakStarted(_this.handleAdBreakStarted, _this);
        _this.adEventsManager.onAdStarted(_this.handleAdStarted, _this);
        _this.adEventsManager.onAdFinished(_this.handleAdFinished, _this);
        _this.adEventsManager.onAdBreakFinished(_this.handleAdBreakFinished, _this);
        _this.adPolicyManager.onCatchupSeek(_this.handleCatchupSeek);
        return _this;
    }
    _create_class(MediaTailorAddon, [
        {
            key: "isWebOS3",
            value: function isWebOS3() {
                return getLgWebOsVersion(CoreVideoInternal.deviceInfo) < 4;
            }
        },
        {
            key: "getAdBreakStartTolerance",
            value: function getAdBreakStartTolerance() {
                var adBreakStartTolerance = AD_BREAK_START_TOLERANCE;
                //TODO: consider moving these values to device-specific config.
                switch(CoreVideoInternal.deviceType){
                    case DeviceType.Chromecast:
                        adBreakStartTolerance = AD_BREAK_START_TOLERANCE_LOW_END;
                        break;
                    case DeviceType.WebOS:
                        if (this.isWebOS3()) {
                            adBreakStartTolerance = 2.3;
                        }
                        break;
                }
                return adBreakStartTolerance;
            }
        },
        {
            key: "getAdBreakEndTolerance",
            value: function getAdBreakEndTolerance() {
                var adBreakEndTolerance = CoreVideoInternal.capabilities.hasLowerEndSpecs() ? 1.4 : 1.2;
                if (CoreVideoInternal.deviceType === DeviceType.WebOS && this.isWebOS3()) {
                    adBreakEndTolerance = 2.4;
                }
                return adBreakEndTolerance;
            }
        },
        {
            key: "prepareAdvertising",
            value: function prepareAdvertising(requestOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.vacAddon) {
                                    _this.logger.warn('Vac addon not initialised yet');
                                    return [
                                        2,
                                        Promise.resolve(null)
                                    ];
                                }
                                if (!_this.config.enableVamProxy) return [
                                    3,
                                    2
                                ];
                                _this.logger.verbose('VAM proxy for MT is enabled');
                                _this.vacDataParams = _this.vacAddon.getVacRequestParameters(requestOptions);
                                return [
                                    4,
                                    _this.vacAddon.getVacRequestHeaders(requestOptions)
                                ];
                            case 1:
                                _this.vacHeaders = _state.sent();
                                return [
                                    2,
                                    Promise.resolve(null)
                                ];
                            case 2:
                                return [
                                    2,
                                    _this.vacAddon.fetchVacResponse(requestOptions)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "bootstrap",
            value: function bootstrap() {
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            Promise.resolve()
                        ];
                    });
                })();
            }
        },
        {
            key: "getModifiedPlayout",
            value: function getModifiedPlayout(playoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var _playoutData_cdns__streamInfo, _firstCdn_streamInfo, _playoutData_cdns, firstCdn, otherCdns, cdnUrl, sessionResponse, fullTrackingUrl, cdnTokenValue, manifestBootstrappedUrl, startPositionIncludingAds, managedStartPosition;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!playoutData.advertising || !_this.config) {
                                    return [
                                        2,
                                        playoutData
                                    ];
                                }
                                if (!_this.config.host) {
                                    _this.logger.warn("No MediaTailor host configured for playback type ".concat(playoutData.type));
                                    return [
                                        2,
                                        playoutData
                                    ];
                                }
                                _this.adEventsManager.setPlayoutData(playoutData);
                                _this.usingExtendedDvrWindowSessionWorkaround = _this.sessionItem.type === PlaybackType.SingleLiveEvent && ((_playoutData_cdns__streamInfo = playoutData.cdns[0].streamInfo) === null || _playoutData_cdns__streamInfo === void 0 ? void 0 : _playoutData_cdns__streamInfo.windowDuration) === DvrWindowDuration.FullEvent;
                                _this.adBreaksProvider.preserveAdBreakData(_this.usingExtendedDvrWindowSessionWorkaround);
                                _playoutData_cdns = _to_array(playoutData.cdns), firstCdn = _playoutData_cdns[0], otherCdns = _playoutData_cdns.slice(1);
                                cdnUrl = new URL(firstCdn.url);
                                _this.session.updateTelemetryMetrics({
                                    key: TelemetryNotificationKey.mediaTailorRequestStart,
                                    value: new Date().getTime()
                                });
                                return [
                                    4,
                                    _this.createSession(playoutData)
                                ];
                            case 1:
                                sessionResponse = _state.sent();
                                if (_this.isDestroyed) {
                                    return [
                                        2,
                                        playoutData
                                    ];
                                }
                                _this.session.updateTelemetryMetrics({
                                    key: TelemetryNotificationKey.mediaTailorResponseEnd,
                                    value: new Date().getTime()
                                });
                                if (_this.config.enableVamProxy) {
                                    _this.advertising.vac = sessionResponse === null || sessionResponse === void 0 ? void 0 : sessionResponse.vamResponse;
                                }
                                if ((sessionResponse === null || sessionResponse === void 0 ? void 0 : sessionResponse.manifestUrl) && _this.usingExtendedDvrWindowSessionWorkaround) {
                                    // Get full event window for infinite pvr
                                    sessionResponse.manifestUrl = sessionResponse.manifestUrl.replace(HARMONIC_2M_PATH, HARMONIC_EVENT_PATH);
                                }
                                if (sessionResponse === null || sessionResponse === void 0 ? void 0 : sessionResponse.trackingUrl) {
                                    fullTrackingUrl = _this.constructUrl(_this.config.host, sessionResponse.trackingUrl);
                                    _this.adBreaksProvider.init(playoutData, {
                                        trackingUrl: fullTrackingUrl,
                                        paginationEnabled: _this.config.enablePagination
                                    });
                                }
                                cdnTokenValue = cdnUrl.searchParams.get(CDN_TOKEN_PARAM_NAME);
                                manifestBootstrappedUrl = _this.constructUrl(_this.config.host, sessionResponse.manifestUrl, cdnTokenValue);
                                if (!checkIsManifestVodType(playoutData.type)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.adBreaksProvider.onParsedManifest()
                                ];
                            case 2:
                                _state.sent();
                                if (!_this.adBreaksProvider.hasAdBreaks) {
                                    return [
                                        2,
                                        playoutData
                                    ];
                                }
                                _state.label = 3;
                            case 3:
                                startPositionIncludingAds = _this.adBreakTimeAdapter.contentTimeToTimeIncludingAds(playoutData.position);
                                managedStartPosition = _this.adPolicyManager.manageStartPosition(startPositionIncludingAds);
                                perfLogger.measure(PerfKey.root, PerfTag.mediaTailorResponse);
                                return [
                                    2,
                                    _this.insertSsaiStitcherType(_object_spread_props(_object_spread({}, playoutData), {
                                        position: managedStartPosition,
                                        cdns: [
                                            _object_spread_props(_object_spread({}, firstCdn), {
                                                url: manifestBootstrappedUrl,
                                                originalUrl: firstCdn.url
                                            })
                                        ].concat(_to_consumable_array(otherCdns), [
                                            firstCdn
                                        ]),
                                        custom: _object_spread_props(_object_spread({}, playoutData.custom), {
                                            requiresMediaSequenceSync: ((_firstCdn_streamInfo = firstCdn.streamInfo) === null || _firstCdn_streamInfo === void 0 ? void 0 : _firstCdn_streamInfo.vendor) === StreamVendor.Harmonic
                                        })
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.logger.info('Destroying Addon');
                this.adEventsManager.removeEventListeners(this);
                this.adEventsManager.destroy();
                this.adPolicyManager.disable();
                this.adBreaksProvider.disable();
                this.adBreaksProvider.removeEventListeners();
                this.isDestroyed = true;
            }
        },
        {
            key: "getSessionSideAdTransitionBoltOn",
            value: function getSessionSideAdTransitionBoltOn() {
                // @ts-ignore
                return;
            }
        },
        {
            key: "getSsaiStitcherType",
            value: function getSsaiStitcherType() {
                return this.adBreaksProvider.ssaiStitcherType;
            }
        },
        {
            key: "getAdPolicyManager",
            value: function getAdPolicyManager() {
                return this.adPolicyManager;
            }
        },
        {
            key: "getAdBreaksProvider",
            value: function getAdBreaksProvider() {
                return this.adBreaksProvider;
            }
        },
        {
            key: "getAdEventsManager",
            value: function getAdEventsManager() {
                return this.adEventsManager;
            }
        },
        {
            key: "getTimedActionsScheduler",
            value: function getTimedActionsScheduler() {
                return undefined;
            }
        },
        {
            key: "getAdsFailoverReason",
            value: function getAdsFailoverReason() {
                return AdsFailoverReason.MediaTailor;
            }
        },
        {
            key: "getAdSuppressionStrategy",
            value: function getAdSuppressionStrategy() {
                var defaultValue = {
                    mode: 'BEHIND_LIVE_EDGE',
                    value: '00:00:00'
                };
                return Object.assign(defaultValue, this.config.availSuppression);
            }
        },
        {
            key: "populateSessionRequestForVamProxy",
            value: function populateSessionRequestForVamProxy(playoutData, cdnUrl, fetchRequest) {
                var _playoutData_advertising;
                var vamConfig = this.getVamConfig((_playoutData_advertising = playoutData.advertising) === null || _playoutData_advertising === void 0 ? void 0 : _playoutData_advertising.vac);
                var mediaTailorSessionEndpoint = new URL("".concat(this.config.host).concat(cdnUrl.pathname, "?").concat(vamConfig));
                var sessionRequestBody = {
                    reportingMode: 'client',
                    availSuppression: this.getAdSuppressionStrategy(),
                    playerParams: {
                        origin_domain: cdnUrl.hostname
                    }
                };
                if (this.config.enableVamProxy) {
                    var vamParameters = this.getVamParameters();
                    sessionRequestBody.vamParams = vamParameters;
                } else {
                    var adParameters = this.getAdParameters(playoutData.advertising);
                    sessionRequestBody.adsParams = adParameters;
                }
                if (this.config.debug) {
                    if (this.config.enableVamProxy) {
                        mediaTailorSessionEndpoint.searchParams.append('debug', 'true');
                    }
                    sessionRequestBody.logMode = 'DEBUG';
                }
                var _this_vacHeaders;
                var headers = (_this_vacHeaders = this.vacHeaders) !== null && _this_vacHeaders !== void 0 ? _this_vacHeaders : new Headers();
                headers.set('Content-Type', 'application/json');
                fetchRequest = _object_spread(_object_spread_props(_object_spread({}, fetchRequest), {
                    method: 'POST',
                    body: JsonUtils.stringify(sessionRequestBody)
                }), this.config.enableVamProxy && {
                    headers: headers
                });
                return {
                    endpoint: mediaTailorSessionEndpoint.toString(),
                    fetchRequest: fetchRequest
                };
            }
        },
        {
            key: "populateVodSessionRequest",
            value: function populateVodSessionRequest(playoutData, fetchRequest, mtUrl, cdnUrl) {
                var _this_sessionItem_adInsertion_mediaTailor, _this_sessionItem_adInsertion, _this_sessionItem_user_ids_mediaTailor, _this_sessionItem_user_ids, _this_sessionItem_user, _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_session_getProposition, _this_session_getProposition1;
                var mediaTailorSessionEndpoint = "".concat(this.config.host);
                /*
         * https://{proxy_hostname}
         * ?vcid={profile_id}
         * &caid={asset_id}
         * &csid={sitesection}
         * &mturl={mt_host+mt+path+cdn_path}
         * &cdn={cdn_host}
         * &sessiontype={vod|linear}
         * &genre={assetMetadata.genre}
         */ var caid = (_this_sessionItem_adInsertion = this.sessionItem.adInsertion) === null || _this_sessionItem_adInsertion === void 0 ? void 0 : (_this_sessionItem_adInsertion_mediaTailor = _this_sessionItem_adInsertion.mediaTailor) === null || _this_sessionItem_adInsertion_mediaTailor === void 0 ? void 0 : _this_sessionItem_adInsertion_mediaTailor.caid;
                if (!caid) {
                    var _playoutData_advertising, _playoutData_advertising1;
                    sdkLogger.warn("expected a valid caid (value to be mapped to the MediaTailor query parameter 'caid') but received: ".concat(caid, ", falling back to ").concat((_playoutData_advertising = playoutData.advertising) === null || _playoutData_advertising === void 0 ? void 0 : _playoutData_advertising.contentId, "."));
                    caid = (_playoutData_advertising1 = playoutData.advertising) === null || _playoutData_advertising1 === void 0 ? void 0 : _playoutData_advertising1.contentId;
                }
                if (mtUrl === undefined) {
                    var errorMsg = 'MediaTailor UHD URL is not set but playback is in UHD, MediaTailor will therefore not be used for this session';
                    sdkLogger.warn(errorMsg);
                    throw new Error(errorMsg);
                }
                mediaTailorSessionEndpoint = appendQueryParams(mediaTailorSessionEndpoint, _object_spread_props(_object_spread({
                    vcid: (_this_sessionItem_user = this.sessionItem.user) === null || _this_sessionItem_user === void 0 ? void 0 : (_this_sessionItem_user_ids = _this_sessionItem_user.ids) === null || _this_sessionItem_user_ids === void 0 ? void 0 : (_this_sessionItem_user_ids_mediaTailor = _this_sessionItem_user_ids.mediaTailor) === null || _this_sessionItem_user_ids_mediaTailor === void 0 ? void 0 : _this_sessionItem_user_ids_mediaTailor.profileid,
                    csid: this.config.siteSection,
                    mturl: "".concat(mtUrl).concat(cdnUrl.pathname),
                    cdn: "".concat(cdnUrl.protocol, "//").concat(cdnUrl.hostname),
                    sessiontype: 'vod',
                    caid: caid,
                    genre: this.convertContentType((_this_sessionItem_reporting = this.sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.genre)
                }, ((_this_session_getProposition = this.session.getProposition()) === null || _this_session_getProposition === void 0 ? void 0 : _this_session_getProposition.toLowerCase()) && {
                    prop: (_this_session_getProposition1 = this.session.getProposition()) === null || _this_session_getProposition1 === void 0 ? void 0 : _this_session_getProposition1.toLowerCase()
                }), {
                    territory: this.config.territory,
                    skydd: this.config.skydd
                }), {
                    shouldNotEncodeURI: true
                });
                fetchRequest = _object_spread_props(_object_spread({}, fetchRequest), {
                    headers: _object_spread_props(_object_spread({}, fetchRequest.headers), {
                        'x-api-key': this.config.apiKey
                    }),
                    method: 'GET'
                });
                return {
                    endpoint: mediaTailorSessionEndpoint,
                    fetchRequest: fetchRequest
                };
            }
        },
        {
            key: "createSession",
            value: function createSession(playoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var _playoutData_stream, _playoutData_advertising, correctMtUrl, url, cdnUrl, mediaTailorSessionEndpoint, fetchRequest, _this_populateSessionRequestForVamProxy, endpoint, vamProxyFetchRequest, _this_populateVodSessionRequest, endpoint1, vodFetchRequest, mediaTailorUrl, mediaTailorPromise;
                    return _ts_generator(this, function(_state) {
                        correctMtUrl = _this.getCorrectMtUrl(((_playoutData_stream = playoutData.stream) === null || _playoutData_stream === void 0 ? void 0 : _playoutData_stream.quality) === StreamQuality.UHD);
                        url = playoutData.cdns[0].url;
                        if (_this.usingExtendedDvrWindowSessionWorkaround) {
                            url = url.replace(HARMONIC_EVENT_PATH, HARMONIC_2M_PATH);
                        }
                        cdnUrl = new URL(url);
                        mediaTailorSessionEndpoint = '';
                        fetchRequest = {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        };
                        if (((_playoutData_advertising = playoutData.advertising) === null || _playoutData_advertising === void 0 ? void 0 : _playoutData_advertising.vac) || _this.config.enableVamProxy) {
                            _this_populateSessionRequestForVamProxy = _this.populateSessionRequestForVamProxy(playoutData, cdnUrl, fetchRequest), endpoint = _this_populateSessionRequestForVamProxy.endpoint, vamProxyFetchRequest = _this_populateSessionRequestForVamProxy.fetchRequest;
                            mediaTailorSessionEndpoint = endpoint;
                            fetchRequest = vamProxyFetchRequest;
                        } else {
                            if (_this.sessionItem.type !== PlaybackType.VOD) {
                                return [
                                    2
                                ];
                            }
                            try {
                                _this_populateVodSessionRequest = _this.populateVodSessionRequest(playoutData, fetchRequest, correctMtUrl, cdnUrl), endpoint1 = _this_populateVodSessionRequest.endpoint, vodFetchRequest = _this_populateVodSessionRequest.fetchRequest;
                                mediaTailorSessionEndpoint = endpoint1;
                                fetchRequest = vodFetchRequest;
                            } catch (e) {
                                return [
                                    2,
                                    Promise.reject(e)
                                ];
                            }
                        }
                        mediaTailorUrl = new URL(mediaTailorSessionEndpoint);
                        cdnUrl.searchParams.forEach(function(value, key) {
                            mediaTailorUrl.searchParams.set(key, value);
                        });
                        mediaTailorPromise = fetch(mediaTailorUrl.href, fetchRequest).then(function(response) {
                            return response.json();
                        });
                        return [
                            2,
                            promiseWithTimeout(mediaTailorPromise, _this.ADVERTS_AVAILABLE_TIMEOUT).catch(function(error) {
                                throw new Error("Request to MediaTailor Session failed because ".concat(error.message));
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getVamConfig",
            value: function getVamConfig(vac) {
                if (this.config.enableVamProxy) {
                    return 'requestVamAPI=true';
                }
                return "mt.config=".concat(vac['mt.config']);
            }
        },
        {
            key: "getVamParameters",
            value: function getVamParameters() {
                if (this.config.enableVamProxy) {
                    var appendedVacParameters = appendQueryParams('', this.vacDataParams);
                    return appendedVacParameters;
                }
            }
        },
        {
            key: "getAdParameters",
            value: function getAdParameters(advertising) {
                if (!this.config.enableVamProxy) {
                    var vac = advertising.vac;
                    var flattenedSlotParams = vac ? Vac.flattenSlotParams(vac.slotParameters) : {};
                    var adsParams = this.encodeAdParameters(_object_spread({}, vac === null || vac === void 0 ? void 0 : vac.globalParameters, vac === null || vac === void 0 ? void 0 : vac.keyValues, flattenedSlotParams));
                    return adsParams;
                }
            }
        },
        {
            key: "encodeAdParameters",
            value: function encodeAdParameters(adParameters) {
                return Object.entries(adParameters).filter(Boolean).reduce(function(acc, param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    return _object_spread_props(_object_spread({}, acc), _define_property({}, key, encodeURIComponent(value)));
                }, {});
            }
        },
        {
            key: "constructUrl",
            value: function constructUrl(host, givenUrl, cdnTokenValue) {
                var fullUrl = givenUrl.indexOf('http') === 0 ? givenUrl : "".concat(host).concat(givenUrl);
                if (cdnTokenValue) {
                    var fullUrlWithToken = new URL(fullUrl);
                    fullUrlWithToken.searchParams.set(CDN_TOKEN_PARAM_NAME, cdnTokenValue);
                    return fullUrlWithToken.toString();
                }
                return fullUrl;
            }
        },
        {
            key: "convertContentType",
            value: function convertContentType(contentType) {
                if (typeof contentType === 'string') {
                    return contentType.toLowerCase();
                }
                return typeof contentType === 'number' ? ContentType[contentType].toLowerCase() : '';
            }
        }
    ]);
    return MediaTailorAddon;
}(ServerAdvertsAddon);

//# sourceMappingURL=legacy-media-tailor-addon.js.map